export enum DASHBOARD_META_TITLES {
  BACKOFFICE = 'Backoffice',
  STATISTICS_PAGE = 'Statistics',
  PAYOUT_ORDER_PAGE = 'Payout orders',
  DOCUMENTS_PAGE = 'Documents',
}
